<template lang="pug">
  v-container.pa-0
    div
      froala(id="edit" :tag="'textarea'" :config="config" v-model="form" @focus="")

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Vue from 'vue'
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import FroalaEditor from 'froala-editor/js/froala_editor.min'
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
// FroalaEditor.DefineIcon('paragraphFormat',{SVG_KEY: 'fontSize'}) 
FroalaEditor.DefineIcon('moreText',{SVG_KEY: 'more'})
 
export default {
  name: 'PageEditor',
  props: ['parentForm'],
  data: vm => ({
    isLoading: false,
    config: {
      events: {
        'image.beforeUpload' (files) {
          var editor = this
          if (!files.length) { return }
          let file = files[0]
          var params = new FormData()
          params.append('file', file)
          vm.$axios.post(`/documents/`, params)
            .then(resp => {
              let url = resp.data.file
              url = url.replace('https://cdn.yezza.io', 'https://img.yezza.io/full-fit-in/700x700')
              editor.image.insert(url, false, null, editor.image.get())
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_upload_document')])
            })
          return false
        }
      },
      key: process.env.VUE_APP_FROALA_API_KEY,
      attribution: false,
      codeBeautifierOptions: {
        indent_inner_html: false,
        indent_size: 4
      },
      // height: screen.width >= 600 ? Number(window.innerHeight) - 320 : Number(window.innerHeight) - 200,
      heightMin: 300,
      toolbarSticky: false,
      toolbarButtons: {
        'moreText': {
          'buttons': [ 'undo', 'paragraphFormat', 'fontSize', 'textColor','backgroundColor', 'insertImage', 'insertVideo', 'bold', 'italic', 'underline', 'strikeThrough', /*'emoticons',*/ 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'redo', 'fullscreen', 'html' ],
          'buttonsVisible': 7
        }
      },
      quickInsertEnabled: false,
      imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
      imageEditButtons: ['imageCaption', 'imageRemove', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove'],
      imageResizeWithPercent: true,
      videoInsertButtons: ['videoBack', '|', 'videoByURL'],
      fontSize: ['8', '9', '10', '11', '12', '14', '18', '24', '30', '36', '48', '60', '72', '96'],
      videoEditButtons: ['videoReplace', 'videoRemove'],
      paragraphFormat: {
        N: 'Normal',
        H1: 'Heading 1',
        H2: 'Heading 2',
        H3: 'Heading 3',
        H4: 'Heading 4',
        PRE: 'Code'
      }
    },
  }),
  computed: {
    ...mapState('user', ['member']),
    form: {
      get () {
        return this.parentForm
      },
      set (newValue) {
        this.$emit('update:parentForm', newValue)
      }
    }
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
  }
}
</script>

<style lang="scss" scoped>

::v-deep .fr-toolbar .fr-command.fr-btn, .fr-popup .fr-command.fr-btn, .fr-modal .fr-command.fr-btn {
  margin: 2px;
}

::v-deep .fr-toolbar .fr-btn-grp {
  margin-left: 4px;
}

::v-deep .fr-toolbar.fr-toolbar-open {
  padding-bottom: 0
}

::v-deep p {
  font-family: $body-font-family;
  font-size: 16px !important;
  line-height: 20px !important;
  letter-spacing: #{(-40/1000)}em !important;
  margin-bottom: 0px !important;
}

::v-deep ul, ol {
padding-left: 0px;
}

::v-deep li {
  font-family: $body-font-family;
  font-size: 16px !important;
  line-height: 20px !important;
  letter-spacing: #{(-40/1000)}em !important;
}
</style>

